(function ($) {
	class CheckoutCustomerAddresses {

		constructor() {
			$(document).gp_ready(this.init)
		}

		init = () => {

			let $component = $('.checkout-customer-addresses')

			// Trigger events
			$component.find('.checkout-customer-addresses__show-all button').gp_on('click', this.show_all)
		}

		show_all = (e) => {
			let $show_all = $(e.currentTarget).parent()
			let $rest_addresses = $show_all.siblings('.checkout-customer-addresses__group--rest')
			let $add_new = $show_all.siblings('.checkout-customer-addresses__add-new')

			//
			$show_all.hide()
			$add_new.show()
			$rest_addresses.slideDown(200)
		}

	}

	new CheckoutCustomerAddresses()

})(jQuery);
